import { render, staticRenderFns } from "./Finalizar.vue?vue&type=template&id=0ca2968c&scoped=true&"
import script from "./Finalizar.vue?vue&type=script&lang=js&"
export * from "./Finalizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2968c",
  null
  
)

export default component.exports